/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Helper module to create {{#crossLink "StaticMapImage"}}{{/crossLink}} instances from
 * already existing {{#crossLink "L.Map"}}{{/crossLink}} instances.
 *
 * @private
 * @class StaticMapImageFactory
 * @module Services
 */
define(['./staticMapImage', 'security', 'display/map'], function(StaticMapImage, Security, L) {
    'use strict';

    /**
     * @ignore
     * Given a L.Map instance it returns a generic object with the necessary configuration to create a valid
     * {{#crossLink "StaticMapImage"}}{{/crossLink}} instance.
     *
     * @param {L.Map} mapInstance
     * @return {Object} StaticMapImage configuration
     */
    function getConfigFromMapInstance(mapInstance) {
        var config = {};
        if (mapInstance.options.layer) {
            config.layer = mapInstance.options.layer;
        }
        if (mapInstance.options.style) {
            config.style = mapInstance.options.style;
        }
        config.key = Security.getKey('services/display');
        config.center = mapInstance.getCenter().wrap();
        config.zoom = mapInstance.getZoom();
        config.width = mapInstance.getSize().x;
        config.height = mapInstance.getSize().y;
        config.language = mapInstance.getLocaleService().getCurrentLocale().getLanguageCode();
        return config;
    }

    /**
     * Returns a configured {{#crossLink "StaticMapImage"}}{{/crossLink}} instance based in the current state of the
     * given {{#crossLink "L.Map"}}{{/crossLink}} instance.
     * @method createFromMapInstance
     * @param {L.Map} mapInstance
     * @return {StaticMapImage}
     */
    function createFromMapInstance(mapInstance) {
        var config = getConfigFromMapInstance(mapInstance);
        return new StaticMapImage(config);
    }

    L.Map.include({
        /* This method is documented directly in map.js due to a yuidoc's bug in the @for tag */
        getStaticMapUrl: function() {
            var result = null;
            createFromMapInstance(this).go(function(url) {
                result = url;
            });
            return result;
        }
    });

    return {
        createFromMapInstance: createFromMapInstance,
        getConfigFromMapInstance: getConfigFromMapInstance
    };
});



// WEBPACK FOOTER //
// ./services/staticMapImage/staticMapImageFactory.js